export function getDropdownItems(choices, roles) {
	if (!choices) {
		return;
	}

	const choicesByRoles = filterChoicesOnRoles(choices, roles);

	return choicesByRoles.map((choice, index) => ({
		key: index,
		value: choice.value,
	}));
}

export function filterChoicesOnRoles(choices, roles) {
	if (!roles) {
		return choices;
	}

	return choices.filter((item) => {
		let hasRequiredRoles = true;
		const requiredRoles = item.requiredRoles?.getShowForRoles();

		if (requiredRoles) {
			hasRequiredRoles = requiredRoles.every((role) =>
				roles.get(role, false),
			);
		}

		return hasRequiredRoles;
	});
}
